import { scrollRight } from "../partials/scrollNav";
window.scrollRight = scrollRight;
function getUrlParameter(name) {
    return new URLSearchParams(window.location.search).get(name) || '';
}
function scrollTabs() {
    const listadoTabs = Array.from(document.querySelectorAll('.blog-categories .ev-tabs__item'));
    const tabContainer = document.getElementsByClassName('js-tab-container')[0];
    const activeTab = listadoTabs.find(tab => tab.classList.contains('active'));
    if (!activeTab) {
        tabContainer.scrollTo({ left: 0, behavior: "smooth" });
        return;
    }
    const tabLeft = activeTab.offsetLeft;
    const tabWidth = activeTab.offsetWidth;
    const containerWidth = tabContainer.clientWidth;
    const containerScrollLeft = tabContainer.scrollLeft + 30;
    let scrollTarget = containerScrollLeft;
    if (tabLeft < containerScrollLeft) {
        scrollTarget = Math.max(0, tabLeft - 20);
    }
    else if (tabLeft + tabWidth > containerScrollLeft + containerWidth) {
        scrollTarget = Math.min(tabLeft - containerWidth / 2 + tabWidth / 2, (tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.scrollWidth) - containerWidth);
    }
    tabContainer === null || tabContainer === void 0 ? void 0 : tabContainer.scrollTo({ left: scrollTarget, behavior: "smooth" });
}
let paths = [
    { path: '/blog/subsidio-de-vivienda', title: 'Subsidio de Vivienda', color: 'blue-category' },
    { path: '/blog/serie-barrios', title: 'Serie Barrios, Estrenar Vivienda', color: 'ev-green-category' },
    { path: '/blog/gran-feria-inmobiliaria', title: 'Gran Feria Inmobiliaria Estrenar Vivienda', color: 'ev-green-category' },
    { path: '/blog/podcast-bienvenido-a-casa', title: 'Podcast, Bienvenido a Casa de Estrenar Vivienda', color: 'ev-green-category' },
    { path: '/blog/estrenar-deko', title: 'Estrenar DEKO', color: 'ev-green-category' },
    { path: '/blog/la-experiencia-de-estrenar', title: 'La Experiencia de Estrenar Vivienda', color: 'ev-green-category' },
    { path: '/blog/financiacion', title: 'Financiación', color: 'purple-category' },
    { path: '/blog/lanzamientos', title: 'Lanzamientos', color: 'wine-category' },
    { path: '/blog/eventos-ferias', title: 'Eventos y Ferias', color: 'yellow-category' },
    { path: '/blog/sostenibilidad', title: 'Sostenibilidad', color: 'green-category' },
    { path: '/blog/inversion-rentabilidad', title: 'Inversión y Rentabilidad', color: 'aqua-category' },
    { path: '/blog/donde-vivir', title: 'Dónde Vivir', color: 'orange-category' },
];
document.addEventListener("DOMContentLoaded", function () {
    var _a, _b, _c, _d;
    let combineValue = getUrlParameter('combine');
    if (document.getElementById('globalNews') && document.getElementById('filteredNews')) {
        const showGlobal = combineValue === '';
        (_a = document.getElementById('globalNews')) === null || _a === void 0 ? void 0 : _a.classList.toggle('d-none', !showGlobal);
        (_b = document.getElementById('filteredNews')) === null || _b === void 0 ? void 0 : _b.classList.toggle('d-none', showGlobal);
    }
    let currentPath = window.location.pathname;
    document.querySelectorAll(".blog-categories .ev-tabs__item").forEach(link => {
        if (link.getAttribute("href") === currentPath) {
            link === null || link === void 0 ? void 0 : link.classList.add("active");
        }
        else {
            link === null || link === void 0 ? void 0 : link.classList.remove("active");
        }
    });
    const experiencePaths = [
        '/blog/serie-barrios',
        '/blog/gran-feria-inmobiliaria',
        '/blog/podcast-bienvenido-a-casa',
        '/blog/estrenar-deko',
        '/blog/la-experiencia-de-estrenar'
    ];
    if (experiencePaths.includes(currentPath)) {
        (_c = document.getElementById('experience')) === null || _c === void 0 ? void 0 : _c.classList.add('active');
    }
    if (document.querySelector("#articlesList .view-content")) {
        (_d = document.querySelector("#articlesList .view-content")) === null || _d === void 0 ? void 0 : _d.insertAdjacentHTML("beforebegin", '<h1 id="categoryTitle" class="category-title__text d-none"></h1>');
    }
    let titleSection = document.getElementById("categoryTitle");
    if (titleSection) {
        paths.forEach(route => {
            if (currentPath == route.path) {
                titleSection.innerHTML = route.title;
                if (document.querySelector("#articlesList .view-content")) {
                    titleSection.classList.add("category-title__text", route.color);
                }
                else {
                    titleSection.classList.add("category-title__text", "centered", route.color);
                }
                let tabSection = document.querySelector(`.blog-categories .ev-tabs__item[href="${route.path}"]`);
                tabSection = tabSection ? tabSection : document.querySelector(`.blog-categories .ev-tabs__item.dropdown-toggle`);
                tabSection === null || tabSection === void 0 ? void 0 : tabSection.classList.add(route.color);
            }
        });
    }
    setTimeout(() => {
        scrollTabs();
    }, 600);
    const floatIframe = document.getElementById("avi-chat-float-frame");
    if (floatIframe === null || floatIframe === void 0 ? void 0 : floatIframe.contentWindow) {
        floatIframe.contentWindow.postMessage({
            type: "AVI_ORIGIN",
            payload: {
                origin: "AVI - Blog",
            },
        }, "*");
    }
});
